const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
const FILE_KEY = 'myFile';
const LOCALE = 'en-GB';
const ONE_HOUR_IN_MS = 60 * 60 * 1000;
const DEV_BUCKET = 'images.quesmed.com';
const PROD_BUCKET = 'quesmed-test';
const ALPHABETS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
enum ETheme {
  DARK = 'dark',
  LIGHT = 'light',
  MODERN = 'modern',
  SYSTEM = 'system',
}

enum EEnvironment {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

enum EDataView {
  GRID = 'grid',
  LIST = 'list',
}

enum EFormMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export {
  ALPHABETS,
  DEV_BUCKET,
  EDataView,
  EEnvironment,
  EFormMode,
  ETheme,
  FILE_KEY,
  LOCALE,
  MAX_FILE_SIZE,
  ONE_HOUR_IN_MS,
  PROD_BUCKET,
};
